import { useQ } from './hooks'
import type { Item, Out } from './generated/types'

export const SearchA = { global: 'search.global' } as const

export type SearchHit = Item<Out<'search.global'>['hits']>
export type SearchHitType = 'client' | 'pet' | 'appointment' | 'visit' | (string & {})

export function useGlobalSearch(query: string) {
  const q = useQ(SearchA.global, { query: query.trim(), limit: 12 }, { enabled: query.trim().length >= 2, staleTime: 30_000 })
  return { ...q, hits: q.data?.hits ?? [], availability: q.availability }
}

/** Route for a search hit. */
export function hitHref(h: Pick<SearchHit, 'type' | 'id' | 'client_id' | 'pet_id' | 'at'>): string {
  switch (h.type) {
    case 'client':
      return `/clients/${h.id}`
    case 'pet':
      return `/pets/${h.id}`
    case 'visit':
      return `/journeys/for?visit=${h.id}`
    case 'appointment':
      return `/journeys/for?appointment=${h.id}`
    case 'call':
      return `/calls/${h.id}`
    case 'task':
      return `/tasks?task=${h.id}`
    case 'journey':
      return `/journeys/${h.id}`
    default:
      return h.client_id ? `/clients/${h.client_id}` : '/'
  }
}
